import React, {createContext, useContext} from 'react';

import {Run} from '../../util/runTypes';

type RunWorkspaceRunProviderProps = {
  children: React.ReactNode;
  run: Run | null;
};

const RunWorkspaceRunContext = createContext<Run | null>(null);

/**
 * Context provider for the run object of a single-run workspace (views with type "run-view").
 * When workspace consolidation flag is enabled, run-view type views will no longer be used.
 * Single-run data will come from the new SingleRunModeContext instead.
 */
export const RunWorkspaceRunProvider = ({
  children,
  run,
}: RunWorkspaceRunProviderProps) => {
  return (
    <RunWorkspaceRunContext.Provider value={run}>
      {children}
    </RunWorkspaceRunContext.Provider>
  );
};

export const useRunWorkspaceRunContext = () => {
  const value = useContext(RunWorkspaceRunContext);
  if (value == null) {
    throw new Error(
      'useRunWorkspaceRunContext must be used within a RunWorkspaceRunContext'
    );
  }
  return value;
};

/** @deprecated use useSingleRunModeContext instead */
export const useRunWorkspaceRunContextMaybe = () => {
  return useContext(RunWorkspaceRunContext);
};

/** @deprecated use useSingleRunModeContext().isSingleRun instead */
export const useIsSingleRunDeprecated = () => {
  return useRunWorkspaceRunContextMaybe() != null;
};
